import { render, staticRenderFns } from "./MessageCenter.vue?vue&type=template&id=36ff9e92&scoped=true"
import script from "./MessageCenter.vue?vue&type=script&lang=js"
export * from "./MessageCenter.vue?vue&type=script&lang=js"
import style0 from "./MessageCenter.vue?vue&type=style&index=0&id=36ff9e92&prod&lang=scss&scoped=true"
import style1 from "./MessageCenter.vue?vue&type=style&index=1&id=36ff9e92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ff9e92",
  null
  
)

export default component.exports